import { request } from "../../apis";

export const apiGetSessionList = (params: any): any =>
  request("get", `/api/session/list`, params, true);
